import { FileTextOutlined } from '@ant-design/icons';
import React from 'react';
import { CancelQuotation, NewQuotation, QuotationReplied, QuotationApproved } from '../../routes/quotation/combi-tasks';

export const CombiQuotationSteps = [
    {
        title: 'New Quotation',
        icon: <FileTextOutlined />,
        status: 1,
        component: () => NewQuotation

    },
    {
        title: 'Quotation Replied',
        icon: <FileTextOutlined />,
        status: 2,
        component: () => QuotationReplied
    },
    {
        title: 'Cancelled',
        icon: <FileTextOutlined />,
        status: 5,
        component: () => CancelQuotation
    },
    {
        title: 'Approved',
        icon: <FileTextOutlined />,
        status: 6,
        component: () => QuotationApproved
    },
]